import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { getParams } from '@distribute/shared/utils';

import { navigate } from '../../../processes/navigation';

import { SidebarBanner } from '../../../features/sidebar-banner';

import { WorkspaceNavigation } from './WorkspaceNavigation';

import { useTeamPermissions } from '../../../features/teams';
import { WorkspaceFolders } from './WorkspaceFolders';
import { Button, Icon } from '../../../shared/ui';
import { IconMap } from '../../../shared/sprite';
import { pageCreationFlowModel } from '../../../processes/page-creation-flow';

import { useCreatePage } from '../../../features/pages/hooks';

export const WorkspaceContent: React.FC = () => {
  const { search, pathname } = useLocation();
  const { handleCreateNewPage } = useCreatePage();

  const dispatch = useDispatch();
  const isNewPageFlowLoading = useSelector(
    pageCreationFlowModel.selectors.selectCreatePageIsLoading
  );

  const { isGuest } = useTeamPermissions();

  useEffect(() => {
    if (getParams(search).get('create-page') === '1') {
      handleCreateNewPage();
      dispatch(navigate({ to: pathname, isKeepQueryParams: false }));
    }
  }, [search, pathname, dispatch, handleCreateNewPage]);

  return (
    <>
      {!isGuest && (
        <>
          <div className="w-full h-px bg-gray-200 flex-shrink-0 md:hidden" />
          <Button
            variant="text"
            color="primary"
            size="lg"
            className="font-semibold shadow-xs !px-4 flex-shrink-0 md:hidden"
            onClick={handleCreateNewPage}
            loading={isNewPageFlowLoading}
          >
            <Icon glyph={IconMap.Plus} width={20} className="mr-1.5" />
            Create new page
          </Button>
          <div className="w-full h-px bg-gray-200 flex-shrink-0 md:hidden" />
          <WorkspaceNavigation />
          <div className="w-full h-px bg-gray-200 flex-shrink-0" />
        </>
      )}
      <WorkspaceFolders />
      <SidebarBanner />
    </>
  );
};
